import {DestroyRef, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {merge, switchMap} from 'rxjs';
import {AllEntriesRemovedEvent} from 'src/app/shared/application/events/entry/all-entries-removed.event';
import {EVENT_BUS} from 'src/app/shared/domain/tokens/event-bus.token';
import {RemoveAllEntriesUseCase} from '../use-cases/remove-all-entries.use-case';

export class RemoveAllEntriesSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly removeAllEntriesUseCase = inject(RemoveAllEntriesUseCase);

  constructor() {
    merge(
      this.eventBus.ofType(AllEntriesRemovedEvent)
    )
      .pipe(
        switchMap((event: AllEntriesRemovedEvent) =>
          this.removeAllEntriesUseCase.execute(event.payload.entriesId)
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
